<button 
  class="map__make-payment-button ci-paragraph-p1-semibold"
  (click)="handleMakePaymentClick()"
>
  @if(!isWaitingForResponse()) {
    {{ 'Realizar pago' | translate }}
  } @else {
    <ci-icon name="loader-debounce" scale="1x"></ci-icon>
    {{ 'Realizando pago...' | translate }}
  }
</button>